/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import ListGroup from 'react-bootstrap/ListGroup';

export const IconImage = styled(Image)`
  width: 30px;
  height: 30px;
`;

export const IconContainer = styled(ListGroup.Item)`
  display: flex;
  align-items: center;
`;

export const SubTitle = styled.h5`
  word-break: break-all;
  font-size: 12px;
`;

export const Title = styled.h4`
  font-weight: bold;
  font-size: 14px;
`;
